import { Routes } from '@angular/router';
import { BranchsListComponent } from './pages/branchs-list/branchs-list.component';
import { ServicesListComponent } from './pages/services-list/services-list.component';
import { InformationsComponent } from './pages/informations/informations.component';
import { YourAppointmentComponent } from './pages/your-appointment/your-appointment.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { SplashComponent } from './pages/splash/splash.component';
import { ContactInfoComponent } from './pages/contact-info/contact-info.component';
import { CheckInComponent } from './pages/check-in/check-in.component';
import { DeepLinkComponent } from './pages/deep-link/deep-link.component';
import { ConfigurationsComponent } from './pages/configurations/configurations.component';
import { TvComponent } from './pages/tv/tv.component';

export const routes: Routes = [
  { path: '', redirectTo: '/branches-location', pathMatch: 'full' },
  { path: 'configuration', component: ConfigurationsComponent},
  { path: 'tv', title: 'Scheduler Queue', component: TvComponent},
  {
    path: 'newevent',
    component: DeepLinkComponent,
    data: { target: 'deeplink' }
  },
  {
    path: 'branches-location',
    component: BranchsListComponent,
    data: { target: 'branch' }
  },
  {
    path: 'services/:id',
    component: ServicesListComponent,
    data: { target: 'service' }
  },
  {
    path: 'calendar',
    component: CalendarComponent,
    data: { target: 'calendar' }
  },
  {
    path: 'cancel/:eventID',
    component: InformationsComponent,
    data: { target: 'cancel' }
  },
  {
    path: 'information/:reason',
    component: InformationsComponent,
    data: { target: 'error' }
  },
  {
    path: 'your-appointment/:id',
    component: YourAppointmentComponent,
    data: { target: 'yourAppointment' }
  },
  {
    path: 'splash',
    component: SplashComponent,
    data: { target: 'splash' }
  },
  {
    path: 'contact-info',
    component: ContactInfoComponent,
    data: { target: 'contact-info' }
  },
  {
    path: 'check-in',
    component: CheckInComponent,
    data: { target: 'check-in'}
  },
  {
    path: 'appointments/scheduled/:id',
    component: YourAppointmentComponent,
    data: { target: 'yourAppointment' }
  },
  { path: '**', redirectTo: '/branches-location', pathMatch: 'full' }
];
